<template>
  <div class="confirmation">
    <v-row no-gutters class="checkClientInfo">
      <v-col
        v-for="(rec, index) in detail"
        :key="index"
        v-bind:class="{
          boxStyle: true,
          boxStyleFirst: index === 0,

          'rounded-bl-lg': index === 0,
          'rounded-br-lg': index === detail.length - 1
        }"
      >
        <div class="titleStyle">
          <span class="titleText"> {{ $t(rec.title) }}</span>
        </div>
        <div class="contentsStyle">
          <slot :name="'box' + index" v-bind:item="rec">
            <InfoSummary :displayData="rec" />
          </slot>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import InfoSummary from '@/components/items/Designs/InfoSummary'

export default {
  components: {
    InfoSummary
  },
  props: {
    detail: {
      type: Array,
      require: true,
      default: () => []
      // [{
      //   title:'string',
      //   name:'string',
      //   postalCode:'string',
      //   address:'string',
      //   phone:'string',
      // }]
    }
  }
}
</script>

<style scoped lang="scss">
.confirmation {
  .titleStyle {
    background-color: rgba(151, 198, 234, 0.1);
    border-bottom: 1px solid #d8d8d8;
    height: 36px;
    display: table;
    width: 100%;
    text-align: center;
  }
  .titleText {
    display: table-cell;
    vertical-align: middle;
    font-size: 12px;
  }
  .contentsStyle {
    // height: 130px;
    padding: 15px 41px;
    font-size: 12px;
  }
  .nameContent {
    font-size: 14px;
  }
  .boxStyle {
    border: 1px solid #d8d8d8;
    margin-top: -1px;
    margin-bottom: -1px;
    // margin-left: -1px;
    margin-right: -1px;
  }
  .boxStyle:last-child {
    margin-right: -1px;
  }
  .boxStyleFirst {
    margin-left: -1px;
  }

  .infoArea > div {
    min-height: 18px;
  }
}
</style>
